/**
 * Initiate an environment specific authentication redirect.
 * In a hybrid app, this will open the URL in the in-app browser.
 * In a web app, this will redirect in the current browser window.
 */
export async function initAuthRedirect(targetUrl: string) {
    if (!__IS_HYBRID_APP__) {
        window.location.href = targetUrl;
        return;
    }

    const {Browser} = await import('@capacitor/browser');
    Browser.open({url: targetUrl, presentationStyle: 'popover'});
}
